import GTM from './gtm'

export default GTM

export { default as convertTermlyConsentsToGTM } from './convertTermlyConsentsToGTM'
